export default [
  {
    path: '/apps/dominios/list',
    name: 'apps-dominios-list',
    component: () => import('@/views/app/dominio/dominio-list/DominioList.vue'),
    meta: {
      pageTitle: 'Dominios',
      resource: 'AdminHanes',
    },
  },
  {
    path: '/apps/dominios/edit/:id',
    name: 'apps-dominios-edit',
    component: () => import('@/views/app/dominio/dominio-edit/DominioEdit.vue'),
    meta: {
      pageTitle: 'Editar Dominio',
      resource: 'AdminHanes',
    },
  },
];
